<template>
  <DialogoFormulario
    title="Formulário Preço Produto"
    ref="dialogo"
    width="400"
    :handler="submit"
  >
    <template v-slot="{ form, errors }">
      <v-row>
        <v-col cols="4">
          <v-text-field
            v-model="form.dias"
            type="number"
            label="Dias"
            autofocus
            outlined
            :error-messages="errors.dias"
          ></v-text-field>
        </v-col>
        <v-col>
          <MoneyInput
            v-model="form.preco"
            label="Preço"
            outlined
            :error-messages="errors.preco"
          ></MoneyInput>
        </v-col>
      </v-row>
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "../../dialogos/DialogoFormulario.vue";
import MoneyInput from "../../MoneyInput.vue";
import api from "@/services/locacoes";

export default {
  mixins: [],

  components: {
    DialogoFormulario,
    MoneyInput
  },

  props: {},

  data() {
    return {
      produto_id: null
    };
  },

  methods: {
    abrir(produto_id, preco = {}) {
      this.produto_id = produto_id;
      this.$refs.dialogo.open(preco);
    },

    fechar() {
      this.$refs.dialogo.close();
    },

    async submit(form) {
      await api.precos_produto.adicionarOuAtualizar(
        this.produto_id,
        form.dias,
        { ...form }
      );
      this.$emit("salvo");
    }
  },

  computed: {}
};
</script>
